import { render } from "./Detalle.vue?vue&type=template&id=10f53adf&scoped=true"
import script from "./Detalle.vue?vue&type=script&lang=js"
export * from "./Detalle.vue?vue&type=script&lang=js"

import "./Detalle.vue?vue&type=style&index=0&id=10f53adf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sisco\\Documents\\logistica\\AppChoferes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f53adf"]])

export default __exports__